<ng-container *ngIf="consultationProcess$ | async; let cp">
    <ng-container *ngIf="validity$ | async; let validity">
        <div class="zas-row">
            <div class="zas-main-col">
                <div class="pcm-button" (click)="showPCM()">
                    <span
                        class="zas-header-icon icon-search tracking-action"
                    ></span>
                    <span class="zbd-inline-button"
                        >Vermittlerdaten befüllen</span
                    >
                </div>
            </div>
        </div>
        <div class="zas-row">
            <zbd-input
                type="text"
                name="agenturNummer"
                label="Agenturnummer"
                [validity]="validity"
                class="zas-main-col"
                [entity]="cp.Agent"
                property="AgencyNumber"
                [updateFn]="persistence.updateAgent"
            ></zbd-input>
            <zbd-input
                type="select"
                name="mandant"
                label="Mandant"
                class="zas-main-col"
                [validity]="validity"
                [entity]="cp"
                property="TenantType"
                [updateFn]="tenantTypeUpdateFn(cp)"
                [locked]="isLocked(cp)"
            >
                <option value="" disabled></option>
                <option
                    *ngFor="let value of getKeys(ZASConstants.TenantTypeTable)"
                    [value]="value"
                >
                    {{ ZASConstants.TenantTypeTable[value] }}
                </option>
            </zbd-input>
        </div>
        <div class="zas-row" *ngIf="cp.TenantType !== 'DB'">
            <zbd-input
                type="text"
                name="agenturName"
                label="Firma"
                [validity]="validity"
                class="zas-main-col"
                [entity]="cp.Agent"
                property="AgencyName"
                [updateFn]="persistence.updateAgent"
                [securityFilter]="'light'"
            ></zbd-input>
            <div class="zas-main-col"></div>
        </div>
        <div class="zas-row">
            <zbd-input
                type="text"
                name="vorname"
                label="Vorname"
                [validity]="validity"
                class="zas-main-col"
                [entity]="(consultationProcess$ | async)?.Agent"
                property="FirstName"
                [updateFn]="persistence.updateAgent"
            ></zbd-input>
            <zbd-input
                type="text"
                name="nachname"
                label="Nachname"
                [validity]="validity"
                class="zas-main-col"
                [entity]="cp.Agent"
                property="LastName"
                [updateFn]="persistence.updateAgent"
            ></zbd-input>
        </div>

        <div class="zas-row zas-headline-3">Adressdaten</div>
        <div class="zas-row">
            <zbd-input
                type="checkbox"
                name="isPostOfficeBox"
                label="Postfach"
                class="zas-main-col"
                [entity]="cp.Agent.Address"
                property="IsPostOfficeBox"
                [updateFn]="persistence.updateAddress"
            ></zbd-input>
        </div>
        <div class="zas-row">
            <zbd-input
                type="select"
                name="land"
                label="Land"
                class="zas-main-col"
                [entity]="cp.Agent.Address"
                property="Country"
                [updateFn]="persistence.updateAddress"
            >
                <option value="">kein</option>
                <option
                    *ngFor="let value of getKeys(ZASConstants.CountryTable)"
                    [value]="value"
                >
                    {{ ZASConstants.CountryTable[value] }}
                </option>
            </zbd-input>
            <div class="zas-main-col">
                <div class="zas-inner-table">
                    <zbd-input
                        type="text"
                        name="plz"
                        label="PLZ"
                        class="col-xs-4 zas-inner-col-left"
                        [entity]="cp.Agent.Address"
                        property="Zip"
                        [updateFn]="persistence.updateAddress"
                    ></zbd-input>
                    <zbd-input
                        type="text"
                        name="ort"
                        label="Ort"
                        class="col-xs-8 zas-inner-col-right"
                        [entity]="cp.Agent.Address"
                        property="City"
                        [updateFn]="persistence.updateAddress"
                    ></zbd-input>
                </div>
            </div>
        </div>
        <div class="zas-row">
            <zbd-input
                *ngIf="!cp.Agent.Address.IsPostOfficeBox"
                type="text"
                name="strasse"
                label="Straße, Hausnummer"
                class="zas-main-col"
                [entity]="cp.Agent.Address"
                property="Street"
                [updateFn]="persistence.updateAddress"
                [securityFilter]="'light'"
            ></zbd-input>
            <zbd-input
                *ngIf="cp.Agent.Address.IsPostOfficeBox"
                type="text"
                name="postOfficeBoxNumber"
                label="Postfachnummer"
                class="zas-main-col"
                [entity]="cp.Agent.Address"
                property="PostOfficeBoxNumber"
                [updateFn]="persistence.updateAddress"
            ></zbd-input>

            <zbd-input
                type="text"
                name="ortsteil"
                label="Ortsteil"
                class="zas-main-col"
                [entity]="cp.Agent.Address"
                property="District"
                [updateFn]="persistence.updateAddress"
            ></zbd-input>
        </div>

        <div class="zas-row zas-headline-3">Kontaktdaten</div>
        <div class="zas-row">
            <zbd-input
                type="text"
                name="telefon"
                label="Telefon"
                class="zas-main-col"
                [entity]="cp.Agent.Address"
                property="PhoneBusiness"
                [updateFn]="persistence.updateAddress"
            ></zbd-input>
            <zbd-input
                type="text"
                name="telefax"
                label="Telefax"
                class="zas-main-col"
                [entity]="cp.Agent.Address"
                property="Telefax"
                [updateFn]="persistence.updateAddress"
            ></zbd-input>
        </div>
        <div class="zas-row">
            <zbd-input
                type="text"
                name="eMail"
                label="E-Mail-Adresse"
                class="zas-main-col"
                [entity]="cp.Agent.Address"
                property="EMail"
                [updateFn]="persistence.updateAddress"
            ></zbd-input>
            <div class="zas-main-col"></div>
        </div>
        <div class="zas-row">
            <zbd-input
                *ngIf="cp.TenantType !== 'DA'"
                type="checkbox"
                name="vorlageVermittlerprofil"
                [label]="
                    cp.TenantType === 'makler'
                        ? strings.profileHandedMakler
                        : strings.profileHandedGeneric
                "
                [validity]="validity"
                class="zas-main-col"
                [entity]="cp"
                property="IsProfileHanded"
                [updateFn]="persistence.updateConsultationProcess"
                appearance="touch"
            ></zbd-input>
        </div>

        <pcm-modal [agent]="cp.Agent" [protocol]="cp.Protocol"></pcm-modal>
    </ng-container>
</ng-container>
